import React from 'react';
import './App.css';
import './global.css';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';

import LoginPage from './pages/LoginPage';
import CoachDashboardPage from './pages/CoachDashboardPage';
import PlayerDetailPage from './pages/PlayerDetailPage';
import CoachPlayersPage from './pages/CoachPlayersPage';
import StyleGuide from './pages/styleguide';
import CreatePlayerPage from './pages/CreatePlayerPage';
import NavBarComponent from './components/NavBarComponent';
import ProtectedRoute from './components/ProtectedRoute';
import EditTeamPage from './pages/EditTeamPage';
import HomePage from './pages/HomePage';
import RegisterCoachPage from './pages/RegisterCoachPage';
import ViewClubPage from './pages/ViewClubPage';
import PlayerProfilePage from './pages/PlayerProfilePage';
import FooterComponent from './components/FooterComponent'; // ✅ Import footer

function App() {
  return (
    <AuthProvider>
      <NavBarComponent />
      <div style={{ paddingTop: '60px', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        {/* Main content */}
        <div style={{ flexGrow: 1 }}>
          <Routes>
            {/* Public Route */}
            <Route path="/" element={<LoginPage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/coach-register" element={<RegisterCoachPage />} />

            {/* Coach-only routes */}
            <Route
              path="/coachdashboard"
              element={
                <ProtectedRoute requiredRole="coach">
                  <CoachDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/players"
              element={
                <ProtectedRoute requiredRole="coach">
                  <CoachPlayersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create-player"
              element={
                <ProtectedRoute requiredRole="coach">
                  <CreatePlayerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-team/:id"
              element={
                <ProtectedRoute requiredRole="coach">
                  <EditTeamPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/club"
              element={
                <ProtectedRoute requiredRole="coach">
                  <ViewClubPage />
                </ProtectedRoute>
              }
            />

            {/* Shared route */}
            <Route
              path="/player/:id"
              element={
                <ProtectedRoute allowedRoles={['coach', 'player']}>
                  <PlayerDetailPage />
                </ProtectedRoute>
              }
            />

            {/* Optional dev-only page */}
            <Route
              path="/styleguide"
              element={
                <ProtectedRoute requiredRole="coach">
                  <StyleGuide />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute allowedRoles={['coach', 'player']}>
                  <PlayerProfilePage />
                </ProtectedRoute>
              }
            />

            {/* Fallback */}
            <Route path="*" element={<div>Page not found</div>} />
          </Routes>
        </div>

        {/* Footer always visible */}
        <FooterComponent />
      </div>
    </AuthProvider>
  );
}

export default App;
